/**
 * Apply high-DPI resolution, drop shadow, and padding to a Phaser text object
 * for crisp rendering on retina/OLED screens.
 *
 * Usage: crispText(this.add.text(x, y, str, style))
 *
 * This sets the text resolution to match the device pixel ratio so Phaser
 * renders the internal canvas at native resolution instead of the (smaller)
 * game-canvas resolution.  A subtle drop shadow and small padding are added
 * to improve readability and prevent clipping.
 */
export function crispText(
  t: Phaser.GameObjects.Text,
  shadow = true,
): Phaser.GameObjects.Text {
  // Render at native device resolution (the single biggest sharpness win)
  t.setResolution(window.devicePixelRatio || 2);

  // Small padding prevents glyphs from clipping at high resolution
  t.setPadding({ x: 4, y: 4 });

  // Subtle drop shadow for depth / readability (skip for decorative text if desired)
  if (shadow) {
    t.setShadow(2, 2, '#000000', 4, true, true);
  }

  return t;
}
